import React, {useState} from 'react';
import { authUrl } from '../../config';
import axios from 'axios';
import { useNavigate,useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useDispatch } from 'react-redux';
import { loginUser } from '../../redux/actions/authActions';

const Code = (props) => {
    const [code,setCode] = useState('');
    const location = useLocation();
    const { email } = location.state || {};
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const sendcode = () => {
        axios.post(`${authUrl}/auth/authemailcode`,{email:email,code:code}).then(res=>{
            const decoded = jwtDecode(res.data.access_token);
            let tokens = res.data;
            console.log('THE DECODED REC',decoded)
            dispatch(loginUser({
                decoded:decoded,
                access_token:res.data.access_token,
                refresh_token:res.data.refresh_token
            }))
            navigate('/')
          }).catch(error=>{
            console.log('ERROR AROUND RTHE CODE',error)
        })
    }
    return (
        <div style={{
            display:'flex',
            flexDirection:'column',
            width:'100%',
            height:'100vh',
            justifyContent:'center',
            alignItems:'center'
        }}>
            <div style={{
                width:'200px',
                display:'flex',
                flexDirection:'column'
            }}>
            <input value={code}
            placeholder="code..."
            onChange={(e)=>{
                setCode(e.target.value)
            }}/>
            <button onClick={sendcode}>
                send code
            </button>
        </div>
        </div>
    )
}

export default Code;